export const TIME_SLOTS: string[] = []
for (let h = 8; h <= 15; h++) {
  TIME_SLOTS.push(`${h.toString().padStart(2, '0')}:00`)
  TIME_SLOTS.push(`${h.toString().padStart(2, '0')}:30`)
}

export const START_TIME_SLOTS = TIME_SLOTS.filter((t) => t <= '15:00')

export const END_TIME_SLOTS = [...TIME_SLOTS, '16:00']
